/** @jsxRuntime classic */
/** @jsx jsx */
// @ts-check
import Card from '@bottlebooks/gatsby-design-system/src/components/Card/Card';
import { jsx } from 'theme-ui';
import ExhibitorsPageCards from '../ExhibitorsPage/ExhibitorsPageCards';
import ExhibitorsList from './ExhibitorsList';

export default function GroupedExhibitorsCard({ type, exhibitors, ...rest }) {
  // TODO implement group header
  return (
    <Card sx={{ backgroundColor: 'nuanced' }} {...rest}>
      <ExhibitorsList sx={{ gridAutoFlow: 'dense', padding: [2, 3] }}>
        <ExhibitorsPageCards
          exhibitors={exhibitors}
          sx={{ boxShadow: 'borderSecondary' }}
        />
      </ExhibitorsList>
    </Card>
  );
}
